import { EventRegistration } from './models';

/**
 * Duplicated in api/src/event/registration-details.ts, which cannot import from
 * army-builder-shared (the API has no path mapping to the UI workspace). The two copies
 * must change together — the server is authoritative, and a UI that disagrees with it
 * either blocks a valid registration or lets an invalid one reach a 400 it cannot explain.
 */

/**
 * Deliberately loose. Its job is to catch `login.user.email` being passed as a name, not to
 * adjudicate what a real name looks like — someone legitimately called "@handle" is not the
 * case being defended against, and a stricter rule would start rejecting real names.
 */
export function isEmailShaped(value?: string): boolean {
    const trimmed = (value ?? '').trim();
    const at = trimmed.indexOf('@');
    if (at <= 0 || at === trimmed.length - 1) {
        return false;
    }
    // No second @, and no whitespace anywhere — "Jamie @ Home" is a name, not an address.
    return trimmed.indexOf('@', at + 1) === -1 && !/\s/.test(trimmed);
}

export function isUsableName(value?: string): boolean {
    const trimmed = (value ?? '').trim();
    return trimmed.length > 0 && !isEmailShaped(trimmed);
}

export function isValidContactEmail(value?: string): boolean {
    const trimmed = (value ?? '').trim();
    return trimmed.length > 0 && isEmailShaped(trimmed);
}

export function registrationDetailsComplete(
    registration: Pick<EventRegistration, 'displayName' | 'contactEmail'> | null | undefined
): boolean {
    if (!registration) {
        return false;
    }
    return isUsableName(registration.displayName) && isValidContactEmail(registration.contactEmail);
}
